/* eslint-disable import/prefer-default-export */
import reducerRegistry from '../../reduxUtils/reducerRegistry';
//import makeRequest from '../../utils/makeRequest';
//import { TOI_LIVE_DOMAIN } from '../../constants';

const reducerName = 'notificationCenter';
const createActionName = name => `toi/${reducerName}/${name}`;

export const RECEIVE_DATA = createActionName('RECEIVE_DATA');

function receiveNotificationCenterData(data) {
  return {
    type: RECEIVE_DATA,
    payload: data,
  };
}

function fetchNotificationCenterData() {
  return Promise.reject(new Error('Something went wrong'));
  // const url = `${TOI_LIVE_DOMAIN}/ncCentreFeed`;
  // return makeRequest.get(url, {}, 'skipfeedengine');
}

function handleNotificationCenterDataError() {
  return {
    type: RECEIVE_DATA,
    payload: [],
  };
}

export function loadNotificationCenterData() {
  return dispatch =>
    fetchNotificationCenterData()
      .then(data => dispatch(receiveNotificationCenterData(data.data)))
      .catch(error => dispatch(handleNotificationCenterDataError(error)));
}

export default function reducer(state = {}, action) {
  switch (action.type) {
    case RECEIVE_DATA:
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
